var _defs, _circle, _ellipse, _g, _g2, _path, _path2, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 200,
    viewBox: "0 0 240 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGlowND",
    x1: 120,
    y1: 20,
    x2: 120,
    y2: 170,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7C3AED",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#5D44FF",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cardBgND",
    x1: 50,
    y1: 30,
    x2: 190,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F8FAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "primaryGradientND",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5D44FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#8B5CF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ringGradientND",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#6366F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#8B5CF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EC4899"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shadowGradientND",
    x1: 120,
    y1: 170,
    x2: 120,
    y2: 190,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5D44FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#5D44FF",
    stopOpacity: 0,
    opacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "dropShadowND",
    x: 25,
    y: 20,
    width: 190,
    height: 150,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 12,
    stdDeviation: 16,
    floodColor: "#5D44FF",
    floodOpacity: 0.12
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 95,
    r: 75,
    fill: "url(#bgGlowND)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 178,
    rx: 70,
    ry: 8,
    fill: "url(#shadowGradientND)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#dropShadowND)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 32,
    width: 156,
    height: 116,
    rx: 16,
    fill: "url(#cardBgND)",
    stroke: "#E2E8F0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 44,
    width: 132,
    height: 20,
    rx: 6,
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 51,
    width: 32,
    height: 6,
    rx: 3,
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 51,
    width: 24,
    height: 6,
    rx: 3,
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 51,
    width: 36,
    height: 6,
    rx: 3,
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54,
    y1: 76,
    x2: 186,
    y2: 76,
    stroke: "#F1F5F9",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 82,
    width: 40,
    height: 6,
    rx: 3,
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 82,
    width: 28,
    height: 6,
    rx: 3,
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 82,
    width: 20,
    height: 6,
    rx: 3,
    fill: "#E2E8F0",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54,
    y1: 98,
    x2: 186,
    y2: 98,
    stroke: "#F1F5F9",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 104,
    width: 24,
    height: 6,
    rx: 3,
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 104,
    width: 36,
    height: 6,
    rx: 3,
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 104,
    width: 30,
    height: 6,
    rx: 3,
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54,
    y1: 120,
    x2: 186,
    y2: 120,
    stroke: "#F1F5F9",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 126,
    width: 36,
    height: 6,
    rx: 3,
    fill: "#E2E8F0",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 126,
    width: 20,
    height: 6,
    rx: 3,
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 126,
    width: 34,
    height: 6,
    rx: 3,
    fill: "#E2E8F0",
    opacity: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 92,
    r: 34,
    fill: "#EEF2FF",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 92,
    r: 28,
    fill: "#FFFFFF",
    stroke: "url(#ringGradientND)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 92,
    r: 20,
    fill: "url(#bgGlowND)",
    stroke: "#C7D2FE",
    strokeWidth: 1.5,
    strokeDasharray: "3 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 87C112 85.8954 112.895 85 114 85H117.586C118.117 85 118.625 85.2107 119 85.5858L121 87.5858C121.375 87.9609 121.883 88.1716 122.414 88.1716H126C127.105 88.1716 128 89.067 128 90.1716V96C128 97.1046 127.105 98 126 98H114C112.895 98 112 97.1046 112 96V87Z",
    fill: "#E0E7FF",
    stroke: "#6366F1",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 117,
    y1: 93,
    x2: 123,
    y2: 93,
    stroke: "#5D44FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 112L154 126",
    stroke: "url(#primaryGradientND)",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 112L154 126",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.4
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M172 40L174 46L180 48L174 50L172 56L170 50L164 48L170 46L172 40Z",
    fill: "url(#primaryGradientND)",
    opacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 118L49.5 122.5L54 124L49.5 125.5L48 130L46.5 125.5L42 124L46.5 122.5L48 118Z",
    fill: "#8B5CF6",
    opacity: 0.75
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 36,
    r: 3,
    fill: "#6366F1",
    opacity: 0.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 100,
    r: 2.5,
    fill: "#EC4899",
    opacity: 0.7
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 74,
    r: 2,
    fill: "#8B5CF6",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.d904042b0d22943e3ce47207a94d60d7.svg";
export { ForwardRef as ReactComponent };